module.exports = __webpack_public_path__ + "img/root000.b02eb049.png";